<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12 pl-0 pr-0">
        <hr class="billing-horizontal-line"/>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 pl-34-pr-33" v-if="newBillingPage && !goToBillingInformation">
      <div class="col-sm-12 col-xs-12 col-md-12 p-0 billing-info">
        <p>{{ $t('billingInfo')}}</p>
        <div class="billing-btns">
          <!-- <button @click="navigateToPaymentMethod" id="change-payment-method" :disabled="disablePaymentMethod()">{{ $t('changePaymentMethod')}}</button> -->
          <button @click="navigateToBillingInformation">{{ $t('changeBillingInfo')}}</button>
        </div>
      </div>
      <div class="">
        <div class="tab-wrapper col-xs-12 p-0 pt-24">
          <div class="tab-section">
            <div class="d-flex tabs col-gap-30">
              <div
                v-for="tab in availableTabsList"
                :key="tab.key"
                class="tab-item cursor-pointer"
                :class="{ active: activeTab === tab.displayFilter }"
                @click="setSelectedTab(tab.displayFilter)"
              >
                {{ translateName(tab.displayFilter) }}
              </div>
            </div>
          </div>
          <div class="list-user-action-section" v-if="activeTab === 'Payment Tracker'">
            <div class="d-flex align-items-center pl-16 pr-16">
              <div class="tab-count font-14" style="flex: 10%;">
                {{ displayData.length }}
                <span v-if="displayData.length === 1">{{ $t('itemText') }}</span>
                <span v-else>{{ $t('items') }}</span>
              </div>
              <div class="tab-search" style="flex: 80%;">
                <input :placeholder="$t('search')" class="search-input-field" type="text" v-model="searchKeyword" @keydown.enter="search" />
                <img class="search-icon" src="/static/images/icons/new_emergo_search_icon.svg" alt="search-icon" />
              </div>
            </div>
            <table class="table table-responsive emergo-table"  :class="{ 'mb-0': !displayData.length }">
              <thead>
                <tr style="background-color: #E6E6E6; !important;">
                  <!-- <th class="" style="width:60px">
                    <div class="checkbox-wrapper">
                      <label class="custom-checkbox">
                        <input v-model="checkAllRegistrations" @click="selectAll()" type="checkbox" />
                        <span class="select-check"></span>
                      </label>
                    </div>
                  </th> -->
                  <template v-for="(header, index) in tableHeaders">
                    <template>
                      <th @click="sortBy(header.id)" :key="index">
                        <div class="tableHeader">
                          <div class="header-ellipsis" :title="translateHeaderName(header.name)">{{ translateHeaderName(header.name) }} </div>
                          <span class="sort-key p-relative" :class="sortOrders[header.id] > 0 ? 'asc' : 'dsc'"> </span>
                        </div>
                      </th>
                    </template>
                  </template>
                </tr>
              </thead>
              <tbody ref="tbodyBox">
        <tr
          v-for="entry in displayData"
          :key="entry.id"
          :id="entry.id"
        >
          <!-- <td style="width: 40px;">
            <div class="checkbox-wrapper">
              <label class="custom-checkbox">
                <input type="checkbox" @click="deselect" :value="entry" v-model="selectedRegistration" />
                <span class="select-check"></span>
              </label>
            </div>
          </td> -->
          <td class="header-ellipsis">
            <span
              v-html="entry.id"
              :title="entry.id"
            ></span>
          </td>
          <td class="header-ellipsis">
            <span
              v-html="entry.billing_type"
              :title="entry.billing_type"
            ></span>
          </td>
          <td class="header-ellipsis">
            <span
            >{{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(entry.value) }}
          </span>
          </td>
          <td class="header-ellipsis">
            <span
              v-html="entry.status"
              :title="entry.status"
            ></span>
          </td>
          <td class="header-ellipsis">
            <span
              v-html="formatDate(entry.date_created)"
              :title="formatDate(entry.date_created)"
            ></span>
          </td>
          <td class="header-ellipsis download">
            <a :href="entry.invoice_url" target="_blank" class="download">
              <span
                v-html="entry.invoice_url"
                :title="entry.invoice_url"
              ></span>
            </a>
          </td>
          </tr>
          </tbody>
            </table>
          </div>
          <div class="list-user-action-section" v-else>
            <div class="col-sm-12 col-xs-12 col-md-12">
        <p class="compliance-tracker-text">{{ $t('savedBillingInformation')}}</p>
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 hr-section">
        <hr class="compliance-horizontal-line"/>
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 billing-contact-section">
        <div class="col-sm-4 col-xs-4 col-md-4 pr-0">
          <p class="billing-contact-text">{{ $t('billingContact')}}</p>
        </div>
        <div class="col-sm-8 col-xs-8 col-md-8 p-0 billing-info-wrapper">
          <button class="billing-wrapper" data-toggle="collapse" data-target="#collpaseBillingInfo" data-parent="#accordion">
            <img src="/static/images/icons/upArrow.svg" class="downCarret" />
            <img src="/static/images/icons/upArrow.svg" class="upCarret" />
          </button>
          <div class="collapse" id="collpaseBillingInfo">
            <ul class="payment-details" >
              <div v-for="(data, index) in userAndCompanyData" :key="data.id" :class="[index === 0 && 'pt-0', index === (userAndCompanyData.length - 1) && 'pb-24']">
              <li><span class="address">{{ $t('address') }}:</span> <span class="billing">{{data.first_name}} {{data.last_name}}, {{data.email}}, {{data.phone}}, {{data.street_address}}, {{data.card_city }}, {{data.card_state}}, {{data.card_postal}}, {{data.country_name}}.</span></li>

              <p class="pt-10"><span class="address">{{ $t('date') }}: </span>{{formatDate(data.date)}}</p>
              </div>
            </ul>
          </div>
        </div>
      </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <template v-if="goToBillingInformation">
      <billing-information ref="billingInformation" :fromDetails="fromDetails" @backToPaymentMethod="navigateToPaymentMethod" :userAndCompanyData="userAndCompanyData" :id="id" @cancelBillingInformationUpdate="cancelBillingInformationUpdate" @closepopup="closepopup" ></billing-information>
    </template>
    <template v-if="goToPaymentMethod">
      <payment-method @goToBilling="navigateToBillingInformation" :fromDetails="fromDetails" @goBackToBillingInfo="cancelBillingInformationUpdate"></payment-method>
    </template>
  </div>
</template>
<script>
import * as moment from 'moment';
import axios from 'axios';
import { validateData } from './BillingValidator';
import Loader from '../UIComponents/Loader.vue';
import BillingInformation from './PSM/BillingInformation.vue';
import PaymentMethod from './PSM/PaymentMethod.vue';
import { getBillingInfo } from '../../apis/psm';
import { getPaymentDetails } from '../../apis/marketPlace';
import {
  isAllCountriesSelected,
  getAvailableRegIntelCountries,
} from '../../apis/regulatoryIntelligence';
import { getProfileData, getCompanyProfileData } from '../../apis/profile';

export default {
  components: {
    Loader,
    BillingInformation,
    PaymentMethod,
  },
  props: ['roleId', 'closeSubPage'],
  data() {
    const gridColumns = ['id', 'billing_type', 'value', 'status', 'invoice_url', 'date_created'];
    const sortOrders = {};
    gridColumns.forEach((key) => {
      sortOrders[key] = -1;
    });
    return {
      id: null,
      fromDetails: {
        fromPage: '',
        paymentId: '',
      },
      userAndCompanyData: [],
      getBillingInfoData: '',
      goToBillingInformation: false,
      goToPaymentMethod: false,
      newBillingPage: true,
      displayNoService: true,
      regIntelPrice: 0,
      mnthvalue: '',
      yearValue: '',
      arrMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      arrYear: [
        1990,
        1991,
        1992,
        1993,
        1994,
        1995,
        1996,
        1997,
        1998,
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
      ],
      user_data: {
        full_name: '',
        credit_card_num: '',
        first_name: '',
        last_name: '',
        security_code: '',
      },
      loaderStatus: false,
      availableTabsList: [{
        displayFilter: 'Billing Details',
        key: 1
      }],
      activeTab: 'Billing Details',
      searchKeyword: '',
      displayPage: 'billing',
      payment_method: '',
      addedPlans: [],
      billingDetails: {},
      filteredData: [],
      checkAllRegistrations: false,
      selectedRegistration: [],
      tableHeaders: [
        {
          id: 'id',
          name: 'Payment ID'
        },
        {
          id: 'billing_type',
          name: 'Method',
        },
        {
          id: 'value',
          name: 'Amount',
        },
        {
          id: 'status',
          name: 'Status'
        },
        {
          id: 'date_created',
          name: 'Date'
        },
        {
          id: 'invoice_url',
          name: 'Invoice Link'
        }
      ],
      sortKey: 'date_created',
      sortOrders,
    };
  },
  validations: {
    user_data: validateData,
  },
  computed: {
    displayData() {
      const { sortKey } = this;
      const order = this.sortOrders[sortKey] || 1;
      let { filteredData } = this;
      // which filters the filteredData based on search input field
      if (this.searchKeyword) {
        this.searchKeyword
          .toLowerCase()
          .split(' ')
          .forEach((search) => {
            filteredData = filteredData.filter((row) =>
              Object.keys(row).some(
                (key) =>
                  String(row[key])
                    .toLowerCase()
                    .indexOf(search) > -1
              ));
          });
      }
      if (sortKey) {
        const properData = [];
        const nonProperData = [];
        if (sortKey === 'date_created') {
          // Date
          let sortKeyDesc = '';
          if (sortKey === 'date_created') {
            // Created Date
            sortKeyDesc = 'date_created';
            for (let i = 0; i < filteredData.length; i += 1) {
              if (moment(filteredData[i].date_created, 'DD/MM/YYYY').isValid()) {
                properData.push(filteredData[i]);
              } else {
                nonProperData.push(filteredData[i]);
              }
            }
          }
          if (order === 1) {
            // Ascending order
            properData.sort((a, b) => {
              const date1 = moment(a[sortKeyDesc]);
              const date2 = moment(b[sortKeyDesc]);
              return date1 - date2;
            });
          } else {
            // Descending order
            properData.sort((a, b) => {
              const date1 = moment(a[sortKeyDesc]);
              const date2 = moment(b[sortKeyDesc]);
              return date1.isBefore(date2) ? 1 : -1;
            });
          }
        } else {
          // Non date
          for (let i = 0; i < filteredData.length; i += 1) {
            if (filteredData[i][sortKey] !== null && filteredData[i][sortKey] !== '') {
              properData.push(filteredData[i]);
            } else {
              nonProperData.push(filteredData[i]);
            }
          }
          const list = [...properData, ...nonProperData].sort((currentRecord, nextRecord) => {
            const currentValue = currentRecord[sortKey];
            const nextValue = nextRecord[sortKey];
            if (currentValue === nextValue) return 0;
            if (currentValue > nextValue) return 1 * order;
            return -1 * order;
          });
          return list;
        }
        filteredData = properData;
        filteredData.push(...nonProperData);
      } // close of if
      return filteredData;
    }
  },
  watch: {
    closeSubPage(val) {
      if (val === 'close') {
        this.navigateToMain();
      }
    },
  },
  methods: {
    formatDate(date) {
      return this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
    },
    disablePaymentMethod() {
      const subscriptionId = JSON.parse(localStorage.getItem('subscriptionId'));
      return subscriptionId !== 2;
    },
    async getBothUserAndCompanyData() {
      return Promise.all([getProfileData(), getCompanyProfileData()]).then(axios.spread((...allData) => ({ ...allData[0], ...allData[1] })));
    },
    navigateToBillingInformation(val) {
      this.fromDetails.fromPage = val.from;
      this.fromDetails.paymentId = val.paymentId;
      this.goToPaymentMethod = false;
      this.goToBillingInformation = true;
      this.$emit('emitBreadCrumb', 'Billing Information');
    },
    navigateToPaymentMethod(val) {
      this.fromDetails.paymentId = val.paymentId;
      this.goToBillingInformation = false;
      this.goToPaymentMethod = true;
      this.$emit('emitBreadCrumb', 'PaymentMethod');
    },
    cancelBillingInformationUpdate() {
      this.getData();
      this.goToBillingInformation = false;
      this.goToPaymentMethod = false;
      this.$emit('emitBreadCrumb', false);
    },
    translateName(name) {
      if (this.$i18n.locale === 'Portuguese') {
        // eslint-disable-next-line no-nested-ternary
        switch (name) {
          case 'Billing Details':
            name = 'Billing_details';
            break;
          case 'Payment Tracker':
            name = 'Payment_tracker';
            break;
          default:
            break;
        }
        const data = {
          Billing_details: 'Detalhes de cobrança',
          Payment_tracker: 'Rastreador de pagamento'
        };
        return data[name];
      }
      return name;
    },
    translateHeaderName(name) {
      if (this.$i18n.locale === 'Portuguese') {
        // eslint-disable-next-line no-nested-ternary
        switch (name) {
          case 'Payment ID':
            name = 'payment_id';
            break;
          case 'Method':
            name = 'method';
            break;
          case 'Amount':
            name = 'amount';
            break;
          case 'Status':
            name = 'status';
            break;
          case 'Invoice Link':
            name = 'invoice';
            break;
          case 'Date':
            name = 'date';
            break;
          default:
            break;
        }
        const data = {
          payment_id: 'ID de Pagamento',
          method: 'Método',
          amount: 'Quantia',
          status: 'Status',
          invoice: 'Link da fatura',
          date: 'Data'
        };
        return data[name];
      }
      return name;
    },
    setSelectedTab(selectedTab) {
      this.activeTab = selectedTab;
    },
    closepopup() {
      if (!this.$refs.billingInformation.disableBillingInformationButton) {
        this.$refs.billingInformation.toggleConfirmPopUp();
      }
    },
    async isAllCountriesSelected() {
      const allMarketsSelected = await isAllCountriesSelected(
        11,
        JSON.parse(localStorage.getItem('userData')).account_id,
      );
      if (allMarketsSelected) {
        this.regIntelPrice = 499;
      } else {
        const selectedIds = await getAvailableRegIntelCountries(JSON.parse(localStorage.getItem('userData')).account_id);
        this.regIntelPrice = (selectedIds.length - 1) * 99;
      }
    },
    async getBillingInfo() {
      this.billingDetails = await getBillingInfo();
    },
    changeContent(page) {
      this.displayPage = page;
      if (
        this.displayPage === 'billinginfo'
        || this.displayPage === 'payment'
      ) {
        const breadCrumb = this.displayPage === 'billinginfo'
          ? 'Edit Billing information'
          : 'Change Payment Method';
        this.$emit('emitBreadCrumb', breadCrumb);
      } else {
        this.$emit('emitBreadCrumb', false);
      }
    },
    navigateToMain() {
      this.displayPage = 'billing';
      this.$emit('emitBreadCrumb', false);
    },
    submitBillingInfo() {
      this.$refs.billingInfo.$v.$touch();
      if (this.$refs.billingInfo.$v.$invalid) {
        return false;
      }
      return true;
    },
    async getData() {
      this.loaderStatus = true;
      this.getBillingInfoData = await getBillingInfo();
      if (this.getBillingInfoData !== null) {
        this.userAndCompanyData = this.getBillingInfoData;
        const ids = this.userAndCompanyData.map((val) => val.id);
        const highestId = Math.max(...ids);
        this.id = highestId;
      } else {
        const res = await this.getBothUserAndCompanyData();
        this.userAndCompanyData = [];
        this.userAndCompanyData.push(res);
        this.id = null;
      }
      localStorage.setItem('previousUserAndCompanyData', JSON.stringify(this.userAndCompanyData));
      this.loaderStatus = false;
    },
    async getPaymentDetails() {
      this.loaderStatus = true;
      const res = await getPaymentDetails();
      this.filteredData = res.data;
    },
    deselectAll() {
      this.checkAllRegistrations = false;
    },
    deselect(event) {
      if (!event.target.checked) {
        this.checkAllRegistrations = false;
      } else if (event.target.checked && this.selectedRegistration.length + 1 === this.filteredData.length) {
        this.checkAllRegistrations = true;
      }
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] *= -1;
    },
  },
  async created() {
    this.getData();
    this.getPaymentDetails();
  },
  filters: {
    dateFormat(date) {
      if (date) {
        return moment(date).format('MM/DD/YYYY');
      }
      return '';
    },
  },
};
</script>
<style scoped>
.billing {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
}
.address {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
.pb-24 {
  padding-bottom: 24px !important;
}
.billing-info-wrapper button {
  position: absolute;
  right: 0;
  border: none;
  background-color: transparent;
  padding: 0;
}
.billing-wrapper[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
.billing-wrapper[aria-expanded="true"] img.downCarret {
  display: none;
}
.billing-wrapper img.downCarret {
  display: inline-block;
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
}
.billing-wrapper img.upCarret {
  display: none;
  width: 24px;
  height: 24px;
}
.billing-btns {
  display: flex;
  column-gap: 16px;
}
.payment-details {
  padding: 14px 0px 0px 0px;
}
#change-payment-method {
  border: none;
  background-color: #E6E6E6;
  border-radius: 3px;
  padding: 7px 16px;
  color: #404040;
}
#change-payment-method:disabled {
  cursor: not-allowed;
}
.billing-contact-section{
  padding-top: 16px;
  padding-right: 50px;
}
.pl-34-pr-33 {
  padding-left: 34px;
  padding-right: 33px;
}
.billing-contact-text{
  font-size: 16px;
  padding-left: 8px;
  color: #333;
  margin: 0px;
}
.compliance-tracker-text{
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin-bottom: 0px;
  padding-left: 19px;
  padding-top: 34px;
}
.billing-info{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
}
.billing-horizontal-line{
  margin-top: 16px;
  margin-bottom: 26px;
  border-top: 1px solid #D3D3D3;
  /* opacity: 0.4; */
}
.billing-contact-section ul{
  list-style-type: decimal;
  margin-bottom: 0px;
  margin-right: 20px;
}
.billing-contact-section li{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.pr-24{
  padding-right: 24px;
}
.billing-info p{
  font-weight: 600;
  font-size: 18px;
  color: #333333;
}
.hr-section{
  padding-left: 34px;
  padding-right: 47px;
}
.compliance-horizontal-line{
  border-top: 1px solid #D3D3D3;
  margin-top: 10px;
  margin-bottom: 0px;
}
.billing-info button{
  background-color: #01518a;
  border: none;
  height: 34px;
  cursor: pointer;
  min-width: 177px;
  border-radius: 3px;
  padding: 6px 16px;
  /* margin-top: 4px; */
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
}
.mr-lt-0.billing-hr-line {
  margin-left: 0px;
}
.tableHeader {
  display: flex;
  align-items: center;
  column-gap: 7px;
}
.header-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tab-section {
  padding: 20px 20px 0px 20px;
  background: #f5f5f5;
}
.tab-item {
  padding-bottom: 10px;
  color: #3e3e3e;
}
.tab-count {
  padding-top: 18px;
  padding-bottom: 17px;
  border-right: 1px solid #d3d3d3;
  color: #4D4D4D;
}
.tab-search {
  position: relative;
  min-height: 55px;
}
.search-input-field {
  padding-left: 50px;
  width: 100%;
  border: 0;
  height: 54px;
  outline: none;
}
.download {
  color: #00518A;
  cursor: pointer;
}
.list-user-action-section {
  background: #ffffff;
  border-top: 1px solid #d3d3d3;
}
.search-icon {
  position: absolute;
  left: 16px;
  top: 15px;
}
.tabs > .active {
  border-bottom: 2px solid #01518a;
  color: #000001;
}
.custom-dropdown
  >>> .multiselect__content-wrapper
  .multiselect__option--highlight {
  color: #000000;
  height: 30px;
  background: #f5f5f5;
}
.custom-dropdown.multiselect--active >>> .multiselect__tags {
  border-radius: 20px;
}
.multiselect--active.custom-dropdown >>> .multiselect__select:before {
  top: 5px;
}
.custom-dropdown >>> .multiselect__option--selected:before {
  content: "\f00c";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: green;
  float: right;
}
.custom-dropdown >>> .multiselect__tags {
  border-radius: 20px;
  min-height: 0;
  border: 1px solid #000000;
  color: #0b3c61;
  height: 35px;
  line-height: 11px;
}
.custom-dropdown >>> .multiselect__placeholder {
  padding-top: 4px;
}
.custom-dropdown >>> .multiselect__content-wrapper {
  min-height: 0px;
  max-height: 180px !important;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.custom-dropdown.multiselect--active::before {
  content: "";
  -webkit-box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
  box-shadow: 3px -2px 6px -4px rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 10px;
  top: 30px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  width: 20px;
  height: 20px;
  background: white;
}
.custom-dropdown.multiselect--active.multiselect--above::before {
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  top: -15px;
}
.custom-dropdown.multiselect--above >>> .multiselect__content-wrapper {
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.25);
}
.custom-dropdown >>> .multiselect__select:before {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  border: 1px solid #0b3c61;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  top: 0;
  content: "";
}
.billingInfo {
  overflow-y: auto;
  height: 64vh;
  overflow-x: hidden;
}
.box-wrapper {
  overflow-y: auto;
  max-height: calc( 84vh - 100px );
  overflow-x: hidden;
}
.current-total {
  padding-left: 20px;
}

.current-total.last hr {
  margin-left: 0px;
}
.billing-hr-line {
  margin-right: 32px;
  margin-left: 40px;
}
.change-payment {
  background: #ffffff;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #0b3c61;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  padding: 6px 14px;
  outline: none;
}
.save-payment-method {
  padding-left: 20px;
}
.payment-method {
  padding-bottom: 16px;
}
.change-payment-left {
  padding-right: 46px;
  padding-left: 0px;
  text-align: end;
}
.rams-billing {
  padding: 110px 38px 37px 57px;
}
.rams-billing p.rams-billing-para {
  font-size: 14px;
  text-align: center;
  background: rgba(103, 177, 226, 0.2);
  padding: 20px 0px;
  border-radius: 6px;
  line-height: 16px;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  color: #000000;
}
.box-wrapper .service-charges {
  padding-left: 20px;
}
.service-charges p,
.billing-header p {
  font-weight: 300;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.box-wrapper .upper-line {
  margin-left: 20px;
  margin-right: 32px;
}
.current-total p.item-name {
  padding-left: 40px;
}

@media only screen and (max-width: 320px) {
  .box-wrapper .service-charges {
    padding-left: 0px;
  }
  .service-charges .dollar-per-month {
    margin-left: 65px;
  }
  .box-wrapper .upper-line {
    margin-left: 0px;
    margin-right: 0px;
  }
  .current-total p.item-name {
    padding-left: 0px;
  }
  .billing-hr-line {
    margin-right: 12px;
    margin-left: 0px;
  }
  .save-payment-method {
    padding-left: 0px;
  }
  .change-payment-left {
    padding-right: 0px;
    padding-left: 0;
    text-align: center;
  }
  .rams-billing {
    padding: 10px 18px 0px 17px;
  }
  .payment-method {
    padding-bottom: 0px;
  }
}

@media (min-width: 321px) and (max-width: 379px) {
  .box-wrapper .service-charges {
    padding-left: 0px;
  }
  .service-charges .dollar-per-month {
    margin-left: 65px;
  }
  .box-wrapper .upper-line {
    margin-left: 0px;
    margin-right: 0px;
  }
  .current-total p.item-name {
    padding-left: 0px;
  }
  .billing-hr-line {
    margin-right: 12px;
    margin-left: 0px;
  }
  .save-payment-method {
    padding-left: 0px;
  }
  .change-payment-left {
    padding-right: 0px;
    padding-left: 0;
    text-align: center;
  }
  .rams-billing {
    padding: 10px 18px 0px 17px;
  }
  .payment-method {
    padding-bottom: 0px;
  }
}

@media (min-width: 380px) and (max-width: 767px) {
  .box-wrapper .service-charges {
    padding-left: 0px;
  }
  .service-charges .dollar-per-month {
    margin-left: 65px;
  }
  .box-wrapper .upper-line {
    margin-left: 0px;
    margin-right: 0px;
  }
  .current-total p.item-name {
    padding-left: 0px;
  }
  .billing-hr-line {
    margin-right: 12px;
    margin-left: 0px;
  }
  .save-payment-method {
    padding-left: 0px;
  }
  .change-payment-left {
    padding-right: 0px;
    padding-left: 0;
    text-align: center;
  }
  .rams-billing {
    padding: 10px 18px 0px 17px;
  }
  .payment-method {
    padding-bottom: 0px;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .box-wrapper {
    max-height: 46vh;
  }
}
@media screen and (width: 768px) {
  .box-wrapper {
    max-height: 52vh;
  }
}
@media screen and (min-width: 768px) {
  .save-payment-method .cred-card {
    padding-left: 40px;
  }
  .edit-button > p {
    margin-right: 32px;
  }
}
@media screen and (max-width: 767px) {
  .edit-button > p {
    margin-right: 12px;
  }
}
.credit-payment-borderTable {
  border: 1px solid #d3d6d9;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 16px;
  padding: 18px 16px 18px 22px;
  margin-bottom: 8px;
}

.styled-checkbox {
  position: absolute;
  opacity: 0;
}
.styled-checkbox + label {
  position: relative;
  cursor: pointer;
  padding: 0;
}
.styled-checkbox + label:before {
  content: "";
  margin-right: 10px;
  margin-top: 4px;
  display: inline-block;
  vertical-align: text-top;
  width: 14px;
  height: 14px;
  border: 1px solid #0b3c61;
  border-radius: 1px;
}
.styled-checkbox:checked + label:after {
  content: "";
  position: absolute;
  left: 2px;
  top: 10px;
  background: white;
  width: 2px;
  height: 2px;
  box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white,
    4px -6px 0 white, 4px -8px 0 white;
  transform: rotate(45deg);
}
.styled-checkbox:checked + label:before {
  background: #0b3c61;
}

/* for radio */
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #0b3c61;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #0b3c61;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.default-card {
  font-size: 24px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
}
.label-payment-method {
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.comn_border {
  background: #ffffff;
  border: 0.5px solid #000000;
  box-sizing: border-box;
  border-radius: 3px;
}
.header-label {
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
span.required_astric {
  color: red;
  font-size: 12px;
  padding-left: 1px;
}
.securityCode {
  width: 114px;
}
.billingInfo .saved-payment-method.selected-box {
  border: 3px solid #4c9e45;
}
.custom-error-class {
  margin-top: 0px;
  margin-bottom: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: #ffebeb;
  padding: 8px;
  padding-left: 15px;
  color: #a20000;
  list-style-type: none;
  display: block;
  font-size: 0.8em;
  text-align: center;
}
@media (min-width: 1025px) and (max-width: 1280px) {
.white-space{
  white-space: nowrap;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  .box-wrapper {
    max-height: 60vh;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px){
  .box-wrapper {
    max-height: 55vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
  .box-wrapper {
    max-height: 60vh;
  }
}
</style>
